import { makeAutoObservable } from "mobx";
import { multiStepOnRowClick } from "src/components/MultiStepTask/utils";
import { TableStore } from "src/components/tables/TableStore";
import { EntityFiltersPageStore } from "src/pages/EntityFiltersPage/EntityFiltersPageStore";
import { ZUid } from "src/types/zUid";
import { RemoteData } from "src/common/RemoteData";
import { delay } from "src/common/delay";
import { cvtError } from "src/common/onError";
import { copyBom3, loaderBom3 } from "../../apiBom3";
import { Bom3Filter, ZBom3 } from "../../ZBom3";

export class Bom3CopyFromStore {
  constructor(
    public readonly params: {
      modelObjectId: ZUid;
      dstModelEntityId: ZUid;
      close(): void;
      onFinish(): void;
    },
  ) {
    this.store1 = new EntityFiltersPageStore({
      objectId: this.params.modelObjectId,
      selectionSettings: { selectionType: "radio" },
      onRowClick: (row) => multiStepOnRowClick(row, this.store1),
    });
    makeAutoObservable(this);
  }

  // --- Step 1
  get selectedModelId(): ZUid | undefined {
    return this.store1.tableStore?.selected[0]?.id;
  }

  get firstDisabled(): boolean {
    return !this.selectedModelId;
  }

  store1: EntityFiltersPageStore;

  // --- Step 2
  get store2() {
    const { selectedModelId } = this;
    if (!selectedModelId) return null;
    return new TableStore<ZBom3, Bom3Filter>({
      rowKey: "id",
      fnLoad: loaderBom3(selectedModelId),
      selectionSettings: {
        selectionType: "checkbox",
      },
      resizableColumns: true,
      settingsKey: "Bom3Control",
    });
  }

  get selectedBomIds(): ZUid[] {
    return this.store2?.selected.map(({ id }) => id) ?? [];
  }

  get secondDisabled(): boolean {
    return this.selectedBomIds.length === 0;
  }

  // -- Step 3
  copyInfo: RemoteData<boolean> = { status: "none" };

  setCopyInfo(data: RemoteData<boolean>) {
    this.copyInfo = data;
  }

  async copy() {
    const { selectedBomIds } = this;
    try {
      this.setCopyInfo({ status: "wait" });
      if (!selectedBomIds?.length) {
        throw Error("No one BOM selected");
      }

      await copyBom3(this.selectedBomIds, [this.params.dstModelEntityId]);

      this.setCopyInfo({ status: "ready", result: true });
      this.params.onFinish();
      await delay(1000); // Пауза для показа сообщения об успешном завершении
      this.params.close();
    } catch (error) {
      this.setCopyInfo({ status: "error", error: cvtError(error) });
    }
  }
}
